import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import Icon from "@/components/common/Icon";
import { Stagger, StaggerItem } from "@/components/common/Reveal";
import { useSettings } from "@/context/SettingsContext";

export default function ServicesSection({ chapter = "01", showAll = true }) {
  const { services = [] } = useSettings();
  const list = showAll ? services : services.slice(0, 6);
  return (
    <section className="container-page py-20 lg:py-28" data-testid="services-section" id="services">
      <SectionHeading
        chapter={chapter}
        eyebrow="Services"
        title="Practical support across your trade journey"
        intro="Editable service coordination from first requirement through to delivery planning — with realistic scope and no exaggerated claims."
      />

      <Stagger className="mt-12 grid gap-px bg-[#D9E0E4] sm:grid-cols-2 lg:grid-cols-3 border border-[#D9E0E4] rounded-lg overflow-hidden">
        {list.map((s) => (
          <StaggerItem key={s.slug}>
            <Link
              to={s.path}
              className="group h-full bg-white p-7 flex flex-col transition-colors hover:bg-[#EAF1F4] focus-visible:bg-[#EAF1F4]"
              data-testid={`service-card-${s.slug}`}
            >
              <div className="flex items-center justify-between">
                <div className="h-11 w-11 rounded-md bg-[#EAF1F4] border border-[#D9E0E4] flex items-center justify-center group-hover:bg-white transition-colors">
                  <Icon name={s.icon} className="h-5 w-5 text-teal" />
                </div>
                <ArrowUpRight className="h-5 w-5 text-[#9AA6AE] group-hover:text-copper transition-colors" />
              </div>
              <h3 className="mt-6 font-heading font-bold text-[19px] text-navy">{s.title}</h3>
              <p className="mt-2 text-[14.5px] leading-relaxed text-muted-foreground flex-1">{s.short}</p>
              <span className="mt-5 text-[13px] font-semibold text-teal inline-flex items-center gap-1">
                Learn more
                <span className="h-px w-6 bg-teal group-hover:w-9 transition-all" />
              </span>
            </Link>
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
}
